import React, { useState, useEffect } from 'react'
import {
  Button,
  Tooltip,
  IconButton,
  ClickAwayListener,
  TextField
} from '@mui/material'

import { useSelector } from 'react-redux'
import StatusProgressbar from '../AppetiteSummary/StatusProgressbar'
import fetchData from '../../utils/fetchData'

const ApplicationSummary = () => {
  const [open, setOpen] = useState(false)
  const selectedApplicationData = useSelector(
    state => state.intakeData.selectedApplicationData
  )
  const applicationDetails = selectedApplicationData?.applicant_info
  const selectedApplicationId = useSelector(
    state => state.intakeData.selectedAppId
  )
  const [statusList, setStatusList] = useState([])
  useEffect(() => {
    fetchData(
      `https://insureai-intake-dev-1074099157700.us-central1.run.app/insureai/ml/intake/applications/v2/application_status?application_id=${selectedApplicationData?.application_id}`,
      'GET'
    ).then(data => {
      setStatusList(data)
    })
  }, [])

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  return (
    <div className='application-details mt-4'>
      {/* Main heading */}
      <h1 className='mb-2 text-2xl'>
        Application Details{' '}
        <span className='text-orange-600'>({selectedApplicationId})</span>
      </h1>
      <div className='p-6 app-content'>
        <div className='flex justify-between'>
          {/* Small Heading */}
          <h2 className='font-semibold'>Summary</h2>
        </div>

        {/* Paragraph Content */}
        <p className='text-gray-700 mb-4'>
          {selectedApplicationData &&
            selectedApplicationData['applicant_info']?.summary}
        </p>

        <p>
          <strong>Application Id:</strong>{' '}
          {selectedApplicationData?.application_id || ''}
        </p>
        <p>
          <strong>Priority:</strong> {selectedApplicationData?.priority}
        </p>
        <p>
          <strong>LOBs:</strong> {selectedApplicationData?.lob || ''}
        </p>
        <p>
          <strong>Classification:</strong>{' '}
          {selectedApplicationData?.application_classification || ''}
        </p>
        <p className='flex'>
          <strong>Details:</strong> {applicationDetails?.summary || ''}
        </p>
        <StatusProgressbar statusList={statusList} className='mt-6' />
      </div>
    </div>
  )
}

export default ApplicationSummary
